import React from 'react';
const stats = [['500+', 'Profesores de EF'], ['12 + 5', 'Tomos y bonos'], ['4.9/5', 'Calificación promedio'], ['Hispanoamérica', 'Confianza en todo el mercado hispanohablante']];
const notes = [['“Planifiqué todo mi año escolar en una sola tarde. Ahora cada clase tiene un objetivo claro y mis alumnos realmente esperan que llegue la hora de Educación Física.”', 'Javier R.', 'Profesor de Primaria'], ['“Mis alumnos mejoran mucho más rápido ahora que siguen una progresión lógica. Esto lo cambió todo.”', 'Coach Miguel', 'Profesor de Secundaria'], ['“Dejé de buscar ideas a último momento. Abro el tomo que corresponde y ya tengo una clase completa para llevar al patio.”', 'Mariana P.', 'Profesora de Educación Física']];
export function ProofSection() {
  return <section className="bg-[#09281d] px-5 pb-16" data-id="element-191" data-mp="3ss2eyodga844">
      <div className="mx-auto max-w-6xl" data-id="element-192" data-mp="1jy81f5nir5u">
        <div className="grid grid-cols-2 border border-emerald-300/25 bg-[#10372a] sm:grid-cols-4" data-id="element-193" data-mp="1kpuo0h9tejz">
          {stats.map(([value, label]) => <div key={label} className="border-b border-r border-emerald-300/15 px-4 py-6 text-center last:border-r-0 sm:border-b-0" data-id="element-194" data-mp="10of0cf62kxk1">
              <p className="font-display text-4xl font-bold uppercase text-emerald-300 sm:text-5xl" data-id="element-195" data-mp="vrespztknmqt">
                {value}
              </p>
              <p className="mt-1 text-[10px] font-bold uppercase tracking-widest text-slate-300" data-id="element-196" data-mp="1oe98ijfg1xxy">
                {label}
              </p>
            </div>)}
        </div>
        <div className="mt-10 grid gap-4 md:grid-cols-3" data-id="element-197" data-mp="1eny46vrulmqj">
          {notes.map(([quote, name, role]) => <figure key={name} className="flex flex-col border border-emerald-950/10 bg-white p-6" data-id="element-198" data-mp="1an4ga2eeo7xn">
              <div className="mb-4 text-amber-500" aria-label="5 de 5 estrellas" data-id="element-199" data-mp="276214cqlph55">
                ★★★★★
              </div>
              <blockquote className="flex-1 text-sm font-medium italic leading-relaxed text-[#09281d]" data-id="element-200" data-mp="fysto20uba9">
                {quote}
              </blockquote>
              <figcaption className="mt-5 border-t border-emerald-950/10 pt-4 text-sm font-bold text-[#09281d]" data-id="element-201" data-mp="5h5wbax4sob4">
                {name}
                <span className="ml-2 text-xs font-medium text-slate-600" data-id="element-202" data-mp="3ru4hpmffwslu">
                  {role}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}